<template>
  <div class="CustomerList">

      <div class="pictrue"><img src="@assets/images/kefu.jpg" /></div>

  </div>
</template>
<script>
import { serviceList } from "@api/user";

export default {
  name: "CustomerList",
  data() {
    return {
      list: []
    };
  },
  methods: {
    getList() {
      serviceList().then(res => {
        this.list = res.data;
      });
    }
  },
  mounted() {
    this.getList();
  }
};
</script>
<style scoped>
.CustomerList {
  margin-top: 0.13rem;
}
.CustomerList .item {
  height: 1.38rem;
  border-bottom: 1px solid #eee;
  padding: 0 0.24rem;
  background-color: #fff;
}
.CustomerList .pictrue {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 0.03rem solid #fff;
  box-shadow: 0 0 0.1rem 0.05rem #f3f3f3;
  -webkit-box-shadow: 0 0 0.1rem 0.05rem #f3f3f3;
  -moz-box-shadow: 0 0 0.1rem 0.05rem #f3f3f3;
}
.CustomerList .pictrue img {
  width: 100%;
  height: 100%;
}
.CustomerList .item .text {
  width: 5.82rem;
  font-size: 0.32rem;
  color: #000;
}

*:not(input,textarea) {
    -webkit-touch-callout: default;
    -webkit-user-select: auto; 
	-moz-user-select: auto;
	-ms-user-select: auto;
	user-select: auto;
}

img{
   pointer-events: auto;
}
</style>
